import React from "react";

export const AvatarIcon = (props:React.SVGProps<SVGSVGElement> & {size?:number|string}) => (
    <svg {...props} width={props.width || props.size || 30} height={props.height || props.size || 30} viewBox="0 0 50 50" fill={props.fill ? props.fill : "none"} xmlns="http://www.w3.org/2000/svg">
        <path d="M17.69 14.34a7.32 7.32 0 0 1 14.62 0 7.32 7.32 0 0 1-14.62 0zM25 24.2a21.25 21.25 0 0 0-11.28 18.78h22.56c0-8.14-4.56-15.2-11.28-18.78z" stroke="CurrentColor" strokeWidth={props.strokeWidth || "2"} strokeMiterlimit="10" strokeLinejoin="round"/>
    </svg>
);
